import { createContext, type Context } from 'react';

import { initialState } from './initialState';
import type { GlobalConfig } from './types';

export const globalConfig: Context<GlobalConfig> = createContext<GlobalConfig>(initialState);
